<div
  class="shop-description-wrapper"
  [class.clickable]="showButton"
  (click)="toggle()"
  (keydown.enter)="toggle()"
  tabindex="0"
  [attr.aria-label]="description"
>
  <p #text class="shop-description-text ods-typography-body-s-regular" [class.collapsed]="collapsed">
    {{ description }}
  </p>
  <button
    class="shop-description-button"
    *ngIf="showButton"
    mat-icon-button
    [attr.aria-label]="collapsed ? 'Collapsed' : 'Expanded'"
  >
    <mat-icon>{{ buttonIcon }}</mat-icon>
  </button>
</div>
